import React, { useState, useContext, useEffect } from 'react';
import { Helper } from 'utils';
import { Api } from 'services';
import { AppActions } from 'store';
import { DispatchContext } from 'context';
import { useSnackbar } from 'notistack';
import './selects.css';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const SelectNacionalidad = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useContext(DispatchContext);
    const [nacionalidades, setNacionalidades] = useState([]);
    useEffect(() => {
        getNacionalidades();
    }, []);
    const getNacionalidades = () => {
        dispatch(AppActions.setLoading(true));
        dispatch(AppActions.setActionsDisabled(true));
        var options = {
            url: Api.route('/solicitudes/solicitudes/lista_nacionalidades'),
            method: 'GET',
            headers: {
                charset: 'utf-8'
            }
        };
        Api.request(options, response => {
            Helper.log('getNacionalidades response', response);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
            if (response.codigo && response.codigo !== 200) {
                enqueueSnackbar(response.mensaje, { variant: 'error' });
            } else if (response.codigo && response.codigo === 200) {
                setNacionalidades(response.datos.nacionalidades);
            }
        }, error => {
            Helper.log('error getNacionalidades', error);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
        });
    };

    const onChange = (event) => {
        props.onChange(event.target.value);
    };
    return (
        <>
            {nacionalidades && nacionalidades.length > 0 ? <FormControl fullWidth size="small">
                <InputLabel id="select-profesion">Nacionalidad{ props.requerido ? <span className="w3-text-theme">&#42;</span> : null}</InputLabel>
                <Select
                    className={props.error ? "w3-border w3-border-red" : "w3"}
                    labelId="select-profesion"
                    id="demo-simple-select"
                    value={props.value}
                    label={<span>Nacionalidad{ props.requerido ? <span className="w3-text-theme">&#42;</span>:null}</span>}
                    onChange={onChange}
                >
                    {nacionalidades.map(nacionalidad => <MenuItem key={nacionalidad.IDNACIONALIDAD} value={nacionalidad.IDNACIONALIDAD}>{nacionalidad.DESCRIPCION}</MenuItem>)}
                </Select>
            </FormControl> : null}
        </>
    );
}
export default SelectNacionalidad;